/* Publish by EComposer at 2026-11-01 13:00:16*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7bvpdnxihbu"]=  window.__ectimmers["ecom-7bvpdnxihbu"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-7bvpdnxihbu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7bvpdnxihbu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-khs01n60rdb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-khs01n60rdb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ms1u756vsq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ms1u756vsq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nhala9gbyu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nhala9gbyu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iclzo5ehaf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iclzo5ehaf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e4xjrgv9osi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e4xjrgv9osi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2gc574uae9m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2gc574uae9m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y7215q1dfx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y7215q1dfx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ile26w3lds').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ile26w3lds', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yz9g6sjcb6g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yz9g6sjcb6g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bbvjm0tyxt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bbvjm0tyxt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ucxanvfelp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ucxanvfelp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y41u3psipcs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y41u3psipcs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ilkk3msr2s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ilkk3msr2s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b9og3fp5bj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b9og3fp5bj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f99o71yumef').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f99o71yumef', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8qz8hx12qea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8qz8hx12qea', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ngzetqp5ww').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ngzetqp5ww', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ilt6az7f2x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ilt6az7f2x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ebtqf9uibuj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ebtqf9uibuj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3wheoypvobu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3wheoypvobu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-68nbdcrz8qe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-68nbdcrz8qe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k090w44dz58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k090w44dz58', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-erjk26olkjo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-erjk26olkjo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3h1kyq33lyr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3h1kyq33lyr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rcacj0bh33b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rcacj0bh33b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kvdbm6wfqbf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kvdbm6wfqbf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6s7ayco7gul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6s7ayco7gul', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1qfim4r89fl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1qfim4r89fl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-whh9es20mc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-whh9es20mc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i1g6mu5857').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i1g6mu5857', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3rqpdj8u997').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3rqpdj8u997', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6walt58sxxx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6walt58sxxx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1jf74g5ux67').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1jf74g5ux67', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sql8y9wftym').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sql8y9wftym', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1zsr8cj8mj6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1zsr8cj8mj6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ba8q8r3p0gm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ba8q8r3p0gm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-etw2mte77yp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-etw2mte77yp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yvz6hsf3vr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yvz6hsf3vr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jx8uhnr9gjb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jx8uhnr9gjb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8t8pkon08hr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8t8pkon08hr', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ed5vgpz1h1g"]=  window.__ectimmers["ecom-ed5vgpz1h1g"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-ed5vgpz1h1g"]["3b0mmrqkq"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ed5vgpz1h1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ed5vgpz1h1g', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-j6lb4x8axrd"]=  window.__ectimmers["ecom-j6lb4x8axrd"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-j6lb4x8axrd"]["auu7x0bkk"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-j6lb4x8axrd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j6lb4x8axrd', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ymdx7en4rx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ymdx7en4rx', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x6udtkjx1ep').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x6udtkjx1ep', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bzsgr4rfgkd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bzsgr4rfgkd', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rzcu14ccjzb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rzcu14ccjzb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oblw2giwts').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oblw2giwts', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r7u4agnvazj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r7u4agnvazj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l20xpl1bat').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l20xpl1bat', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f400g5m75lk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f400g5m75lk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p09rose7dp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p09rose7dp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qbqrm72bdo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qbqrm72bdo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z1bjmy2a3b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z1bjmy2a3b', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s3nt1cubuwl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s3nt1cubuwl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mxprg47dlxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mxprg47dlxm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6yziocuut4g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6yziocuut4g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-34kl84iuld8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-34kl84iuld8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ek0o0f6kr7s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ek0o0f6kr7s', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ns83qsymgg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ns83qsymgg', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}